/* eslint-disable max-lines */
import React, { useState, useEffect, useLayoutEffect, } from 'react';
import { DateTime } from 'luxon';
import { Alert, Button, Drawer, DrawerHeader, DrawerBody, DrawerFooter, LoadingButton, Tile, TileText, TileGroup, } from '@one-thd/sui-atomic-components';
import { DateCalendar } from '@one-thd/sui-date-pickers';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { ApplyReschedulesAPI } from '../../../api/rms/reschedules';
import { catchRescheduleModalOpen, catchReschedulePremiumModalOpen, } from '../../../utils/reschedules/analytics';
import { makeGuestRequestBody } from '../../../utils/guest-order-tracking-utils';
import { getGuestOrderTracking } from '../../../api/oms/guest-order-tracking';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');
var renderTimes = function (startTime, endTime) {
    var showTimezone = false;
    if ((parseInt(startTime === null || startTime === void 0 ? void 0 : startTime.slice(0, 2), 10) <= 12 &&
        parseInt(endTime === null || endTime === void 0 ? void 0 : endTime.slice(0, 2), 10) <= 12) ||
        (parseInt(startTime === null || startTime === void 0 ? void 0 : startTime.slice(0, 2), 10) >= 12 &&
            parseInt(endTime === null || endTime === void 0 ? void 0 : endTime.slice(0, 2), 10) >= 12)) {
        showTimezone = true;
    }
    var startString = new Date('1970-01-01T' + startTime + 'Z')
        .toLocaleTimeString('en-US', {
        timeZone: 'UTC',
        hour12: true,
        hour: 'numeric',
        minute: (startTime === null || startTime === void 0 ? void 0 : startTime[3]) !== '0' ? 'numeric' : undefined,
    })
        .replace(/\s/g, '');
    var endString = new Date('1970-01-01T' + endTime + 'Z')
        .toLocaleTimeString('en-US', {
        timeZone: 'UTC',
        hour12: true,
        hour: 'numeric',
        minute: (endTime === null || endTime === void 0 ? void 0 : endTime[3]) !== '0' ? 'numeric' : undefined,
    })
        .replace(/\s/g, '');
    if (showTimezone === true) {
        startString = startString === null || startString === void 0 ? void 0 : startString.slice(0, -2);
    }
    return "".concat(startString, "\u2013").concat(endString);
};
var disableDates = function (availableSlotsData, setFilteredDates, currentReservation, setAlignment) {
    var _a, _b, _c, _d, _e, _f;
    var data = availableSlotsData.data;
    var availableDeliverySlots = data.availableDeliverySlots;
    if ((_a = availableDeliverySlots === null || availableDeliverySlots === void 0 ? void 0 : availableDeliverySlots[0]) === null || _a === void 0 ? void 0 : _a.slotList) {
        var newJson2Arr_1 = [];
        availableDeliverySlots === null || availableDeliverySlots === void 0 ? void 0 : availableDeliverySlots.map(function (day) {
            var _a;
            var availableDate = day === null || day === void 0 ? void 0 : day.availableDate;
            var slotList = [];
            (_a = day === null || day === void 0 ? void 0 : day.slotList) === null || _a === void 0 ? void 0 : _a.filter(function (slot) {
                if ((slot === null || slot === void 0 ? void 0 : slot.slots) > 0) {
                    slotList.push(slot);
                }
                return null;
            });
            return newJson2Arr_1.push({ availableDate: availableDate, slotList: slotList });
        });
        if (currentReservation) {
            var firstSlot = newJson2Arr_1 &&
                ((_c = (_b = newJson2Arr_1 === null || newJson2Arr_1 === void 0 ? void 0 : newJson2Arr_1[0]) === null || _b === void 0 ? void 0 : _b.slotList) === null || _c === void 0 ? void 0 : _c.filter(function (slot) {
                    var _a, _b;
                    if (parseInt(renderTimes(slot === null || slot === void 0 ? void 0 : slot.startTime, slot === null || slot === void 0 ? void 0 : slot.endTime).replace(/\D/g, ''), 10) ===
                        parseInt((_b = (_a = currentReservation === null || currentReservation === void 0 ? void 0 : currentReservation.split(',')[1]) === null || _a === void 0 ? void 0 : _a.replace(/\s/g, '')) === null || _b === void 0 ? void 0 : _b.replace(/\D/g, ''), 10)) {
                        return renderTimes(slot === null || slot === void 0 ? void 0 : slot.startTime, slot === null || slot === void 0 ? void 0 : slot.endTime);
                    }
                    return null;
                }));
            if (firstSlot && firstSlot.length > 0) {
                setAlignment(renderTimes((_d = firstSlot === null || firstSlot === void 0 ? void 0 : firstSlot[0]) === null || _d === void 0 ? void 0 : _d.startTime, (_e = firstSlot === null || firstSlot === void 0 ? void 0 : firstSlot[0]) === null || _e === void 0 ? void 0 : _e.endTime));
            }
            else {
                setAlignment(undefined);
            }
        }
        setFilteredDates(newJson2Arr_1);
        var newArray_1 = [];
        newJson2Arr_1 === null || newJson2Arr_1 === void 0 ? void 0 : newJson2Arr_1.map(function (day) {
            var _a;
            if (((_a = day === null || day === void 0 ? void 0 : day.slotList) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                var date = (day === null || day === void 0 ? void 0 : day.availableDate) && new Date(day === null || day === void 0 ? void 0 : day.availableDate);
                newArray_1.push(date && (date === null || date === void 0 ? void 0 : date.toISOString()));
                // return date && date.toISOString();
            }
            return undefined;
        });
        return newArray_1;
    }
    if (!((_f = availableDeliverySlots === null || availableDeliverySlots === void 0 ? void 0 : availableDeliverySlots[0]) === null || _f === void 0 ? void 0 : _f.slotList)) {
        var newJson = availableDeliverySlots === null || availableDeliverySlots === void 0 ? void 0 : availableDeliverySlots.filter(function (date) { return (date === null || date === void 0 ? void 0 : date.slots) === 0; });
        return newJson === null || newJson === void 0 ? void 0 : newJson.map(function (day) {
            var date = (day === null || day === void 0 ? void 0 : day.availableDate) && new Date(day === null || day === void 0 ? void 0 : day.availableDate);
            return date && date.toISOString();
        });
    }
    return undefined;
};
var errorText = "We weren't able to save changes to your scheduled delivery. Try saving\nagain.";
var errorSelectText = 'Select a delivery window to reschedule your delivery.';
var renderError = function (rescheduleError, noTimeSelected) {
    return (React.createElement("div", null, rescheduleError && (React.createElement(Alert, { status: "error" }, noTimeSelected === 'noTimeSelected' ? errorSelectText : errorText))));
};
var filterTimeSlots = function (filteredDates, modalDate, alignment, handleAlignment) {
    return filteredDates === null || filteredDates === void 0 ? void 0 : filteredDates.map(function (day) {
        var _a, _b;
        if ((day === null || day === void 0 ? void 0 : day.slotList) &&
            ((_a = day === null || day === void 0 ? void 0 : day.slotList) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            typeof modalDate === 'string' &&
            (day === null || day === void 0 ? void 0 : day.availableDate) === DateTime.fromISO(modalDate).toFormat('LL/dd/yyyy')) {
            return (React.createElement(TileGroup, { value: alignment, onChange: handleAlignment, "aria-label": "rate" }, (_b = day === null || day === void 0 ? void 0 : day.slotList) === null || _b === void 0 ? void 0 : _b.map(function (el) { return (React.createElement(Tile, { value: renderTimes(el === null || el === void 0 ? void 0 : el.startTime, el === null || el === void 0 ? void 0 : el.endTime), "aria-label": "blue", style: { marginRight: '10px', marginBottom: '10px' }, selected: renderTimes(el === null || el === void 0 ? void 0 : el.startTime, el === null || el === void 0 ? void 0 : el.endTime) === alignment },
                React.createElement(TileText, null, renderTimes(el === null || el === void 0 ? void 0 : el.startTime, el === null || el === void 0 ? void 0 : el.endTime)))); })));
        }
        return null;
    });
};
var applyReschedule = function (orderDetailsData, availableSlotsData, modalDate, reschedule, isDFSRescheduleEnabled, fulfillmentType, setRescheduleError, setRescheduleLoading, isAuthTHDUser, alignment, daySlotsList) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (alignment === null) {
        return setRescheduleError(true);
    }
    var findSlot;
    if (modalDate) {
        if (daySlotsList && (daySlotsList === null || daySlotsList === void 0 ? void 0 : daySlotsList.slotList)) {
            if (((_b = (_a = daySlotsList === null || daySlotsList === void 0 ? void 0 : daySlotsList.slotList) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.type) === 'All Day') {
                findSlot = (_c = daySlotsList === null || daySlotsList === void 0 ? void 0 : daySlotsList.slotList) === null || _c === void 0 ? void 0 : _c[0];
            }
            if (((_e = (_d = daySlotsList === null || daySlotsList === void 0 ? void 0 : daySlotsList.slotList) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.type) !== 'All Day') {
                findSlot = (_f = daySlotsList === null || daySlotsList === void 0 ? void 0 : daySlotsList.slotList) === null || _f === void 0 ? void 0 : _f.find(function (day) {
                    var _a;
                    var finalStartTime;
                    if (parseInt(day === null || day === void 0 ? void 0 : day.startTime, 10) > 12) {
                        finalStartTime = parseInt(day.startTime, 10) - 12;
                    }
                    if (parseInt(day === null || day === void 0 ? void 0 : day.startTime, 10) < 12) {
                        finalStartTime = parseInt(day.startTime, 10);
                    }
                    if (alignment) {
                        if (((_a = day === null || day === void 0 ? void 0 : day.startTime) === null || _a === void 0 ? void 0 : _a.slice(0, 2)) === (alignment === null || alignment === void 0 ? void 0 : alignment.slice(0, 2))) {
                            return day;
                        }
                        if (finalStartTime === parseInt(alignment === null || alignment === void 0 ? void 0 : alignment.slice(0, 1), 10)) {
                            return day;
                        }
                    }
                    return null;
                });
            }
        }
        var orderNumber = orderDetailsData.orderNumber, emailId = orderDetailsData.emailId, net = orderDetailsData.net;
        var data = availableSlotsData.data;
        var et = data.et;
        var finalDate = typeof modalDate === 'string' &&
            ((_g = DateTime.fromISO(modalDate)) === null || _g === void 0 ? void 0 : _g.toFormat('yyyy-LL-dd'));
        var convertedFulfillmentType = (_h = convertedFulfillmentTypes(fulfillmentType)) === null || _h === void 0 ? void 0 : _h.toUpperCase();
        if (orderNumber && emailId) {
            var requestData_1;
            if (daySlotsList !== undefined) {
                requestData_1 = {
                    orderId: orderNumber,
                    emailId: emailId,
                    net: net,
                    et: et,
                    rescheduledDate: finalDate || '',
                    fulfillmentType: convertedFulfillmentType || '',
                    slot: {
                        type: (findSlot === null || findSlot === void 0 ? void 0 : findSlot.type) || '',
                        startTime: (findSlot === null || findSlot === void 0 ? void 0 : findSlot.startTime) || '',
                        endTime: (findSlot === null || findSlot === void 0 ? void 0 : findSlot.endTime) || '',
                    },
                };
            }
            else {
                requestData_1 = {
                    orderId: orderNumber,
                    emailId: emailId,
                    net: net,
                    et: et,
                    rescheduledDate: finalDate || '',
                    fulfillmentType: convertedFulfillmentType || '',
                };
            }
            var callApplyReschedulesAPI_1 = function (token) {
                ApplyReschedulesAPI(requestData_1, reschedule, isDFSRescheduleEnabled, fulfillmentType, setRescheduleError, setRescheduleLoading, isAuthTHDUser, token, orderDetailsData.traceId, daySlotsList);
            };
            if (isAuthTHDUser) {
                callApplyReschedulesAPI_1();
            }
            else {
                var custPhone = orderDetailsData.custPhone || '';
                var requestToken = makeGuestRequestBody(orderNumber, emailId, custPhone);
                getGuestOrderTracking(requestToken)
                    .then(function (response) {
                    var _a;
                    var token = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.xAuthGuestToken;
                    if (token)
                        callApplyReschedulesAPI_1(token);
                })
                    .catch(function () {
                    setRescheduleError(true);
                    setRescheduleLoading(false);
                });
            }
        }
    }
    return null;
};
var rescheduleModal = function (modalDate, setModalDate, firstDay, lastDay, open, handleClose, unavailableDateSet, orderDetailsData, availableSlotsData, reschedule, isDFSRescheduleEnabled, fulfillmentType, rescheduleError, setRescheduleError, applyRescheduleLoading, setRescheduleLoading, isAuthTHDUser, filteredDates, alignment, handleAlignment, daySlotsList, currentReservation, finalDisplay) {
    var handleOnChange = function (event, value) {
        if (value) {
            setModalDate(value);
        }
    };
    var type = '';
    if (alignment === null) {
        type = 'noTimeSelected';
    }
    return (React.createElement("div", null,
        React.createElement(React.Fragment, null,
            React.createElement(Drawer, { open: open, onClose: function () { return handleClose(setRescheduleError); }, position: "right", height: "100%" },
                React.createElement(DrawerHeader, { title: "Reschedule Delivery", onClose: function () { return handleClose(setRescheduleError); } }),
                React.createElement(DrawerBody, null,
                    React.createElement(DateCalendar, { value: modalDate || firstDay, minDate: firstDay, maxDate: lastDay, onChange: handleOnChange, unavailableDates: unavailableDateSet }),
                    filteredDates ? (React.createElement("div", { className: "sui-mb-4 sui-mt-4" }, "Available Delivery Windows*")) : (''),
                    filteredDates &&
                        filterTimeSlots(filteredDates, modalDate, alignment, handleAlignment)),
                React.createElement(DrawerFooter, null,
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-min-w-full sui-gap-2 sui-mt-8" },
                        filteredDates && currentReservation && finalDisplay ? (React.createElement("div", { className: "sui-pb-2" },
                            "Delivery Scheduled for",
                            React.createElement("div", { className: "sui-font-bold" }, finalDisplay))) : (''),
                        renderError(rescheduleError, type),
                        React.createElement(LoadingButton, { loading: applyRescheduleLoading, fullWidth: true, style: { width: '100%', marginBottom: '5px' }, onClick: function () {
                                return applyReschedule(orderDetailsData, availableSlotsData, modalDate, reschedule, isDFSRescheduleEnabled, fulfillmentType, setRescheduleError, setRescheduleLoading, isAuthTHDUser, alignment, daySlotsList);
                            } }, "Save Changes"),
                        React.createElement(Button, { fullWidth: true, variant: "secondary", style: { width: '100%' }, onClick: function () { return handleClose(setRescheduleError); } }, "Close")))))));
};
var RescheduleModal = function (props) {
    var _a, _b, _c;
    var _d = useState(), unavailableDateSet = _d[0], setUnavailableDates = _d[1];
    var _e = useState(), filteredDates = _e[0], setFilteredDates = _e[1];
    var _f = useState(), firstDay = _f[0], setFirstDay = _f[1];
    var _g = useState(), modalDate = _g[0], setModalDate = _g[1];
    var _h = useState(false), rescheduleError = _h[0], setRescheduleError = _h[1];
    var _j = useState(false), applyRescheduleLoading = _j[0], setRescheduleLoading = _j[1];
    var _k = useState(), alignment = _k[0], setAlignment = _k[1];
    var _l = useState(), daySlotsList = _l[0], setDaySlotsList = _l[1];
    var _m = useThdCustomer(), isLoggedIn = _m.isLoggedIn, isExchangeCustomer = _m.isExchangeCustomer;
    var isAuthTHDUser = isLoggedIn && !isExchangeCustomer;
    var open = props.open, handleClose = props.handleClose, orderDetailsData = props.orderDetailsData, availableSlotsData = props.availableSlotsData, reschedule = props.reschedule, isDFSRescheduleEnabled = props.isDFSRescheduleEnabled, fulfillmentType = props.fulfillmentType, currentReservation = props.currentReservation, deliveryDisplayText = props.deliveryDisplayText;
    var rescheduleAnalytics = function () {
        var _a, _b, _c, _d, _e;
        var filterdData = (_b = (_a = availableSlotsData === null || availableSlotsData === void 0 ? void 0 : availableSlotsData.data) === null || _a === void 0 ? void 0 : _a.availableDeliverySlots) === null || _b === void 0 ? void 0 : _b.filter(function (slot) { var _a; return (slot === null || slot === void 0 ? void 0 : slot.slotList) && ((_a = slot === null || slot === void 0 ? void 0 : slot.slotList) === null || _a === void 0 ? void 0 : _a.length) > 0; });
        if (((_e = (_d = (_c = filterdData === null || filterdData === void 0 ? void 0 : filterdData[0]) === null || _c === void 0 ? void 0 : _c.slotList) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.type) === 'All Day') {
            return catchRescheduleModalOpen(fulfillmentType);
        }
        return catchReschedulePremiumModalOpen();
    };
    var setSlots = function () {
        var _a;
        var currentDate = modalDate &&
            typeof modalDate === 'string' &&
            ((_a = DateTime.fromISO(modalDate)) === null || _a === void 0 ? void 0 : _a.toFormat('LL/dd/yyyy'));
        var currentSlots = filteredDates === null || filteredDates === void 0 ? void 0 : filteredDates.find(function (el) { return currentDate === (el === null || el === void 0 ? void 0 : el.availableDate); });
        setDaySlotsList(currentSlots);
    };
    var handleAlignment = function (event, newAlignment) {
        setSlots();
        setAlignment(newAlignment);
        setRescheduleError(false);
    };
    useEffect(function () {
        setSlots();
    });
    useLayoutEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        rescheduleAnalytics();
        setUnavailableDates(disableDates(availableSlotsData, setFilteredDates, currentReservation, setAlignment));
        var getFirstDate = [];
        if ((_b = (_a = availableSlotsData === null || availableSlotsData === void 0 ? void 0 : availableSlotsData.data) === null || _a === void 0 ? void 0 : _a.availableDeliverySlots[0]) === null || _b === void 0 ? void 0 : _b.slotList) {
            getFirstDate = (_d = (_c = availableSlotsData === null || availableSlotsData === void 0 ? void 0 : availableSlotsData.data) === null || _c === void 0 ? void 0 : _c.availableDeliverySlots) === null || _d === void 0 ? void 0 : _d.filter(function (date) { var _a; return (date === null || date === void 0 ? void 0 : date.slotList) && ((_a = date === null || date === void 0 ? void 0 : date.slotList) === null || _a === void 0 ? void 0 : _a.length) > 0; });
        }
        if (!((_f = (_e = availableSlotsData.data) === null || _e === void 0 ? void 0 : _e.availableDeliverySlots[0]) === null || _f === void 0 ? void 0 : _f.slotList)) {
            getFirstDate = availableSlotsData.data.availableDeliverySlots.filter(function (date) { return (date === null || date === void 0 ? void 0 : date.slots) && (date === null || date === void 0 ? void 0 : date.slots) > 0; });
        }
        var date2 = ((_g = getFirstDate === null || getFirstDate === void 0 ? void 0 : getFirstDate[0]) === null || _g === void 0 ? void 0 : _g.availableDate) &&
            new Date((_h = getFirstDate === null || getFirstDate === void 0 ? void 0 : getFirstDate[0]) === null || _h === void 0 ? void 0 : _h.availableDate).toISOString();
        setFirstDay(date2);
        setModalDate(date2);
    }, []);
    var getNonSlotDates = (_b = (_a = availableSlotsData === null || availableSlotsData === void 0 ? void 0 : availableSlotsData.data) === null || _a === void 0 ? void 0 : _a.availableDeliverySlots) === null || _b === void 0 ? void 0 : _b.filter(function (date) {
        var _a, _b;
        if ((date === null || date === void 0 ? void 0 : date.slotList) && ((_a = date === null || date === void 0 ? void 0 : date.slotList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return ((_b = date === null || date === void 0 ? void 0 : date.slotList) === null || _b === void 0 ? void 0 : _b.length) > 0;
        }
        if ((date === null || date === void 0 ? void 0 : date.slots) && (date === null || date === void 0 ? void 0 : date.slots) > 0) {
            return (date === null || date === void 0 ? void 0 : date.slots) > 0;
        }
        return null;
    });
    var lastDay = new Date(((_c = getNonSlotDates === null || getNonSlotDates === void 0 ? void 0 : getNonSlotDates.pop()) === null || _c === void 0 ? void 0 : _c.availableDate) || '').toDateString();
    return rescheduleModal(modalDate, setModalDate, firstDay, lastDay, open, handleClose, unavailableDateSet, orderDetailsData, availableSlotsData, reschedule, isDFSRescheduleEnabled, fulfillmentType, rescheduleError, setRescheduleError, applyRescheduleLoading, setRescheduleLoading, isAuthTHDUser, filteredDates, alignment, handleAlignment, daySlotsList, currentReservation, deliveryDisplayText);
};
export default RescheduleModal;
